import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { CHALLENGES } from '../calculatorConstants';
import styles from '../Calculator.module.css';

interface StepChallengesProps {
    selectedChallenges: string[];
    onSelect: (challenge: string) => void;
}

const StepChallenges: React.FC<StepChallengesProps> = ({ selectedChallenges, onSelect }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.challenges.title')}</h3>
                <p className={styles.subtitle}>{t('calculator.challenges.subtitle')}</p>
            </div>
            <div className={styles.optionsContainer}>
                {CHALLENGES.map((challenge, index) => (
                    <label
                        key={challenge}
                        className={`${styles.option} ${
                            selectedChallenges.includes(challenge) ? styles.selected : ''
                        }`}
                    >
                        <input
                            type="radio"
                            name="challenge"
                            checked={selectedChallenges.includes(challenge)}
                            onChange={() => onSelect(challenge)}
                            className={styles.radio}
                        />
                        <span className={styles.radiomark}></span>
                        {t(`calculator.challenges.${index + 1}`)}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default StepChallenges;
